import { Modal, Button, Row, Col } from "react-bootstrap";
import React from "react";

export type SimpleInfoModalProps = {
  show: boolean;
  onHide: () => void;
  title: string;
  body: React.ReactNode;
  buttonText?: string;
  fontAwesomeIcon?: React.ReactNode; // Pass a FontAwesomeIcon component here
};

const noBorder = { borderBottom: "none", borderTop: "none" } as React.CSSProperties;
const leftFooter = { ...noBorder, justifyContent: "flex-start", display: "flex" } as React.CSSProperties;
const SimpleInfoModal = ({ show, onHide, title, body, buttonText = "Close", fontAwesomeIcon }: SimpleInfoModalProps) => (
  <Modal show={show} onHide={onHide} centered size="lg" contentClassName="simple-info-modal-content">
    <div style={{ position: "relative", background: "#fff", borderRadius: 8, padding: 0, minHeight: 320 }}>
      {/* Close X button */}
      <button
        onClick={onHide}
        aria-label="Close"
        style={{
          position: "absolute",
          top: 12,
          right: 16,
          background: "transparent",
          border: "none",
          fontSize: 22,
          color: "#888",
          cursor: "pointer",
          zIndex: 2
        }}
      >
        &times;
      </button>
      <Row style={{ height: "100%", minHeight: 320 }}>
        <Col style={{ display: "flex", flexDirection: "column", justifyContent: "center", padding: "40px 32px 32px 40px" }}>
          <div style={{ marginBottom: 16 }}>
            <h2 style={{ fontWeight: 600, fontSize: 28, marginBottom: 12 }}>{title}</h2>
            <div style={{ fontSize: 16, color: "#333", marginBottom: 24 }}>{body}</div>
          </div>
          <Button variant="primary" onClick={onHide} style={{ alignSelf: "flex-start", minWidth: 100 }}><strong>{buttonText}</strong></Button>
        </Col>
          {fontAwesomeIcon && (
          <Col className="d-none d-lg-flex" style={{ display: "flex", justifyContent: "center", alignItems: "center", background: "#f7f7f7", borderTopRightRadius: 8, borderBottomRightRadius: 8 }}>
              <span style={{ width: "60%", display: "flex", justifyContent: "center", fontSize: "7rem", color: "var(--bs-primary)" }}>
                {fontAwesomeIcon}
              </span>         
          </Col>
         )}
      </Row>
    </div>
  </Modal>
);

export default SimpleInfoModal;
